import { useRef } from 'react';
import './MeetOrbiinComponent.css';
import { useScrolledInto } from '../responsive/scroll';
import orbiinIcon from '../Images/orbiin_logo_yellow_GOOD.png';

const MeetOrbiinComponent = () => {
    const sectionRef = useRef(null);
    // Lines/dots reveal, then the logo (were showDetails and >= 3150)
    const showDetails = useScrolledInto(sectionRef, 0.656);
    const showLogo = useScrolledInto(sectionRef, 0.461);
    const logoImage = () => {
            return <img 
                id="yellow-orbiin-logo"
                src={orbiinIcon} 
                alt="Orbiin Logo Yellow"
            />
    }

    return <div ref={sectionRef} id="meet-orbiin" className="viewport grid-parent meet-layout">
        <div className="meet-title">
            <span className="title-meet">Meet Orbiin</span><br />
            <span className="subtitle-meet">Built for the Flow</span>
        </div>

        <div className="logo">
            { showLogo ? logoImage() : ""}
        </div>

        <div id="meet-yellow-line-1"></div>
        <div id="meet-dot-1" className="dot" style={showDetails ? {opacity: 1}:{}}>
                <div className="dot-outer dot-yellow-transparent dot-yellow-animate">
                    <div className="dot-yellow dot-inner"></div>
                </div>
        </div>
        <div id="meet-line-mask-1" style={showDetails ? {marginLeft: '380px', opacity: 0} : {}}></div>
        <div id="meet-yellow-line-2"></div>
        <div id="meet-dot-2" className="dot" style={showDetails ? {opacity: 1}:{}}>
                <div className="dot-outer dot-yellow-transparent dot-yellow-animate">
                    <div className="dot-yellow dot-inner"></div>
                </div>
        </div>

        <div className="watch-the-road-pop popout-road-text popout-border">
            <span className='pop-bold'>Orbiin</span> watches the road<br />
            so you can focus on the drive
        </div>
        <div id="watch-road-mask" style={showDetails ? {marginLeft: '450px'} : {}}></div>
        <div className="recognize-effort-pop popout-text popout-border recognize-layout">
            <div className="meet-inner-panel">
                <div className="efforts-p">
                    Efforts should be recognized<br/>
                    Every safe move earns something back
                </div>
                <div className="points-strip">Points. Badges. Rewards.</div>
            </div>
        </div>
        <div id="recognize-line-mask" style={showDetails ? {marginTop: '51px', opacity: 0} : {}}></div>
        <div id="recognize-box-mask" style={showDetails ? {marginTop: '285px', opacity: 0} : {}}></div>
        <a id="orbiin-link" href="https://www.orbiin.com">orbiin.com</a>
    </div>
}

export default MeetOrbiinComponent;